import React from 'react';

export const AppleIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="18"
    height="18"
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill="currentColor"
      d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.22-1.98 1.09-3.13-1.05.04-2.31.7-3.06 1.58-.69.8-1.29 2.08-1.13 3.3 1.2.09 2.42-.61 3.1-1.75z"
    />
  </svg>
);

export const PlayIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="18"
    height="18"
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill="#34A853"
      d="M3.2 2.2 14.6 12 2.7 21.8c-.4-.4-.7-.9-.7-1.5V3.7c0-.6.2-1.1.6-1.4l.6-.1z"
    />
    <path fill="#FBBC04" d="M18.9 9.5 15.8 7.6 3.2 2.2 14.6 12l4.3-2.5z" />
    <path fill="#EA4335" d="M18.9 14.5 14.6 12 3.2 21.8l11.7-5.6 4-1.7z" />
    <path
      fill="#4285F4"
      d="M21.2 10.9c.5-.3.8-.8.8-1.3s-.4-1-.9-1.3l-3.5-1.8-3 2.5 3 2.5 3.6.4z"
    />
    <path
      fill="#4285F4"
      d="M14.6 12 18.9 14.5l3.6.4c.5-.3.9-.8.9-1.3 0-.4-.2-.8-.7-1.1L18.9 11.2 14.6 12z"
    />
  </svg>
);
